import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image } from "react-bootstrap";
import moment from "moment";
import { amApi } from "../../../../api/apiHelper";
import isEmpty from "../../../../store/validation/is-Empty";
import NoContent from "../../../reusableComponents/NoContentComponent";
import SelectFilter from "../../../reusableComponents/selectFilter";

function DunzoStatements(props) {
  const [details, setDetails] = useState([]);
  const [dateQuery, setDateQuery] = useState(
    props?.history?.location?.state?.dateQuery || {}
  );
  const [state, setState] = useState(false);
  const onDateChangeHandler = () => (data, type) => {
    if (state) {
      setDateQuery(data);
    } else {
      setState(true);
    }
  };

  useEffect(() => {
    async function fetchData() {
      let response = await amApi(
        `/dunzoMerchantSettlements/${props?.history?.location?.state?.vendor_id}?from=${dateQuery.startDate}&to=${dateQuery.endDate}`
      );
      setDetails(response.data);
    }
    if (!isEmpty(dateQuery)) {
      fetchData();
    }
  }, [dateQuery]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon
              link={`#`}
              displayText="Back"
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Account statement
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("LL")}
                  </div>
                </div>
              </div>
              <div className="row flexcenter">
                <div className="col-4 d-flex"></div>
                <div className="col-5"></div>
                <div className="col-3 d-flex justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="w-50 f16-700">All Transactions</div>
              </div>
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "20%" }} className="f12-400">
                        Restaurant Name
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Order Type
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Price
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Delivery charge
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        User Name
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Pick up
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Drop location
                      </td>
                    </tr>
                  </thead>
                  {details?.length ? (
                    details.map((data) => <TableBody data={data} />)
                  ) : (
                    <NoContent />
                  )}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = ({ data }) => {
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr>
                <td style={{ width: "20%" }}>
                  <div>
                    <h5 className="font_16_m">
                      {data?.restaurantDetails?.restaurant_name || ""}
                    </h5>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <h3 className="font_20_m">
                    Home Delivery <br />
                    {data?.orderDetails?.order_id}
                  </h3>
                </td>
                <td style={{ width: "10%" }}>
                  ₹ {(data?.price || 0).toFixed(2)}
                </td>
                <td style={{ width: "10%" }}>
                  ₹ {(data?.estimated_price || 0).toFixed(2)}
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {data?.userDetails?.first_name || ""}{" "}
                    {data?.userDetails?.last_name || ""}
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  {data?.restaurantDetails?.restaurant_address || ""}
                </td>
                <td style={{ width: "20%" }}>
                  {data?.deliveryAddress?.address1 + "," || ""}{" "}
                  {data?.deliveryAddress?.address2 + "," || ""}{" "}
                  {data?.deliveryAddress?.area + "," || ""}{" "}
                  {data?.deliveryAddress?.city + "," || ""}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default DunzoStatements;
